import { useContext } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { AuthContext } from '@marketplace/common';

import { API_ROUTES } from '../../constants';
import type {
  TAPIPutDeveloperResponse,
  TAPIPutDeveloperpassowrd,
  TAPIDeveloperRequest,
} from './put-developer-password-types';

export const useAPIPutDeveloperResetPassowrd = (): TAPIPutDeveloperpassowrd => {
    const { developerContext } = useContext(AuthContext);
    const { data, error, put, response, loading } = useFetch(
      API_ROUTES.DEVELOPERS,
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
    );
  
    const putDeveloperResetPassword = async (
      body: TAPIDeveloperRequest
    ): Promise<TAPIPutDeveloperResponse> => {
      if (developerContext?.external_id) return put(`/${developerContext?.id}/reset-password`, body);
  
      return {
        data: {},
      };
    };
  
    return {
      data: data?.data,
      error,
      loaded: response?.ok,
      loading,
      putDeveloperResetPassword,
    };
  };
  